export default __webpack_public_path__ + "static/media/UB.be2d48c2.png";